import { getToken } from "./auth";

const API_BASE = import.meta.env.VITE_API_BASE ?? "/api";

export class ApiError extends Error {
  constructor(public status: number, public body: unknown) {
    super(typeof body === "object" && body && "error" in body ? String((body as { error: unknown }).error) : `HTTP ${status}`);
    this.name = "ApiError";
  }
}

export async function api<T>(
  path: string,
  init: RequestInit & { auth?: boolean; json?: unknown } = {}
): Promise<T> {
  const { auth = true, json, headers, ...rest } = init;
  const h: Record<string, string> = {
    Accept: "application/json",
    ...(headers as Record<string, string> | undefined),
  };
  if (auth) {
    const token = await getToken();
    if (token) h.Authorization = `Bearer ${token}`;
  }
  if (json !== undefined) {
    h["Content-Type"] = "application/json";
    rest.body = JSON.stringify(json);
  }
  const res = await fetch(`${API_BASE}${path}`, { ...rest, headers: h });
  if (!res.ok) {
    let body: unknown = null;
    try { body = await res.json(); } catch { /* ignore */ }
    throw new ApiError(res.status, body);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
